module.exports = __webpack_public_path__ + "img/bg.d70284d9.jpg";